import React from 'react';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';

export const WebLayout = ({ children }) => {
  return (
    <div className="font-louis-george">
      <Navbar />
      {children}
      <Footer />
    </div>
  );
};
